var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { row: _vm.horizontal, "align-items-center": _vm.horizontal } },
    [
      !_vm.hiddenLabel
        ? _c("label", { class: _vm.labelClass }, [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("bank_accounts.my_account")) + "\n    "
            ),
            _c("span", { staticClass: "color-red" }, [_vm._v("* ")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.inputClass }, [
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.senderBank,
                expression: "senderBank",
              },
            ],
            staticClass: "form-control min-h-30px border-radius-10px",
            class: { errorBorder: _vm.senderBankError },
            attrs: { id: "sel2", readonly: "", disabled: _vm.disabled },
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.senderBank = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "" } }, [
              _vm._v(_vm._s(_vm.$t("creation_forms.slct_an_acc"))),
            ]),
            _vm._v(" "),
            _vm._l(_vm.bankAccounts, function (bankAccount) {
              return _c(
                "option",
                {
                  key: bankAccount.id,
                  attrs: { disabled: !_vm.isBankAccountAvailable(bankAccount) },
                  domProps: { value: bankAccount.iban },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(bankAccount.name) +
                      " (" +
                      _vm._s(
                        _vm.$engine.bankAccounts.getCurrency(
                          bankAccount.zoneCode
                        )
                      ) +
                      ")\n      "
                  ),
                ]
              )
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.inputIcon
          ? _c("i", {
              staticClass: "color-black",
              class: _vm.inputIcon,
              attrs: { size: "17px" },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.senderBankError
        ? _c("div", { staticClass: "color-red" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$t("errors.is_mandatory", {
                    mandatoryValue: _vm.$t("common.act"),
                  })
                ) +
                "\n  "
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }